import ApiConstants from "../../Constants/ApiConstant";
import { apiGet, apiPost } from "../../Services/ApiService";

export const latestWalletTransactionUrl = (data, callback) => {
  return async () => {
    try {
      await apiGet(ApiConstants.latestWalletTransactionUrl)
        .then((response) => {
          callback && callback(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("latest wallet transaction api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("latest wallet transaction api err:", err);
      throw err;
    }
  };
};

export const createManufacturerAPIUrl = (data, callback) => {
  return async () => {
    try {
      await apiPost(ApiConstants.becomeAManufacturerUrl, data)
        .then((response) => {
          callback && callback(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("create manufacturer api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("create manufacturer api err:", err);
      throw err;
    }
  };
};
